import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, cls} from '../../components/utils';
import {useGlossaryItemsQuery} from '../../generated/types';
import {useRoute} from '../../lib/routes';
import {GlossaryView} from './view';
import {glossaryTypeToString} from '../../components/enums';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const GlossaryPage: React.FC<Props> = () => {
	const {data, loading, error} = useGlossaryItemsQuery({
		ssr: true,
	});

	const router = useRoute();
	const query = router?.query || {};

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.glossaryItems || [],
		id: query.id as string,
		loading,
		route: 'glossaryItem',
		baseRoute: 'glossary',
		sidebarHeader: (glossary) => glossary.title || '',
		sidebarSecondary: (glossary) => glossary.type && glossaryTypeToString(glossary.type),
	});

	const title = showView && selected ? selected.title : 'Глоссарий';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="glossary" />}
			{notFound && <NotFoundSeo />}
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<GlossaryView glossaryItemId={selectedId} title={title} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите правило</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
